import { axios } from "../../lib/axios";
import { ApiError } from "../../types/ApiError";
type SalesDTO = {
    id:string;
    firstName:string;
    lastName:string;
    email:string;
    img_url:string;
    createdAt:string;
    updatedAt:string;
};

type getSalesResponse = {
  statusCode?: number;
  error?: null | ApiError;
  data?: SalesDTO[];
};
export const GetAllSales = async (
): Promise<getSalesResponse> => {
  try {
    const response = await axios.get(`/sales`);
    return { data: response.data };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: any) {
    console.error("API Error:", error);
    if (error.response) {
      const apiError: ApiError = {
        statusCode: error.response.status,
        message: error.response.data.message,
        error: error.response.data.error,
      };
      return { error: apiError };
    } else {
      const fallbackError: ApiError = {
        statusCode: 500,
        message: "An unexpected error occurred",
      };
      return { error: fallbackError };
    }
  }
};
